// 登录状态存在本机存储里，键与旧界面（WeKnora 的 Vue 前端）一致：两边同源，登录一次两边都能用。
// 这些键是上游的内部约定，升级上游时如果变了，只改这里。

import type { User, Tenant } from './types'

export const KEYS = {
  token: 'weknora_token',
  refresh: 'weknora_refresh_token',
  user: 'weknora_user',
  tenant: 'weknora_tenant',
  selectedTenantId: 'weknora_selected_tenant_id',
  selectedTenantName: 'weknora_selected_tenant_name',
} as const

const get = (key: string) => {
  try {
    return localStorage.getItem(key)?.trim() || null
  } catch {
    return null
  }
}
const set = (key: string, value: string | null) => {
  try {
    if (value === null) localStorage.removeItem(key)
    else localStorage.setItem(key, value)
  } catch {
    // 拿不到存储：这一页里仍然能用，刷新后要重新登录
  }
}
const json = <T>(key: string): T | null => {
  const raw = get(key)
  if (!raw) return null
  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export const getToken = () => get(KEYS.token)
export const getRefreshToken = () => get(KEYS.refresh)
export const getSelectedTenantId = () => get(KEYS.selectedTenantId)
export const getStoredUser = () => json<User>(KEYS.user)
export const getStoredTenant = () => json<Tenant>(KEYS.tenant)

export function setTokens(token: string, refresh?: string | null) {
  set(KEYS.token, token)
  if (refresh) set(KEYS.refresh, refresh)
}

/** 登录成功：和旧界面一样，只有当前空间不是自己的主空间时才记下所选空间。 */
export function saveLogin(input: { token: string; refreshToken?: string | null; user: User; tenant?: Tenant | null }) {
  setTokens(input.token, input.refreshToken)
  set(KEYS.user, JSON.stringify(input.user))
  if (input.tenant) {
    set(KEYS.tenant, JSON.stringify(input.tenant))
    if (String(input.tenant.id) !== String(input.user.tenant_id)) {
      set(KEYS.selectedTenantId, String(input.tenant.id))
      set(KEYS.selectedTenantName, input.tenant.name ?? '')
    }
  }
}

export function clearSession() {
  for (const key of Object.values(KEYS)) set(key, null)
}

export const isLoggedIn = () => getToken() !== null
